import {
  Card,
  CardActionArea,
  CardContent,
  Divider,
  Grid,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import * as React from "react";
import axios from "axios";
import { useSetAssignment } from "../../globals/AssignmentContext";
import { useClass } from "../../globals/ClassContext";
const { REACT_APP_DEBUGGER_SERVER_URL } = process.env;

export default function AssignmentsOverview(props) {
  const classroom = useClass();
  const assignments = classroom.assignments;
  const { filter } = props;
  const { openModal } = props;

  const [assignmentObjects, setAssignmentObjects] = React.useState([]);

  React.useEffect(() => {
    const fetchAssignments = async () => {
      let data = [];
      if (assignments.length > 0 && typeof assignments[0] === "string") {
        const requests = assignments.map((id) =>
          axios.get(`${REACT_APP_DEBUGGER_SERVER_URL}/assignment/${id}`)
        );
        const responses = await axios.all(requests);
        data = responses.map((response) => response.data);
      } else {
        data = assignments;
      }

      const today = new Date();

      const filteredAssignments = data.filter((assignment) => {
        const assignmentDueDate = new Date(assignment.due_date);
        const assignmentOpenDate = assignment.open_date
          ? new Date(assignment.open_date)
          : 0;

        if (filter === "open") {
          return today >= assignmentOpenDate && today <= assignmentDueDate;
        } else if (filter === "closed") {
          return today >= assignmentOpenDate && assignmentDueDate < today;
        } else if (filter === "unopened") {
          return today <= assignmentOpenDate && assignmentDueDate > today;
        }
        return true;
      });

      if (filter === "unopened") {
        filteredAssignments.sort(
          (a, b) => new Date(a.open_date) - new Date(b.open_date)
        );
      } else if (filter === "closed") {
        filteredAssignments.sort(
          (a, b) => new Date(b.due_date) - new Date(a.due_date)
        );
      } else {
        filteredAssignments.sort(
          (a, b) => new Date(a.due_date) - new Date(b.due_date)
        );
      }

      setAssignmentObjects(filteredAssignments);
    };

    if (typeof assignments != "undefined") fetchAssignments();
  }, [classroom, assignments, filter]);

  return (
    <Stack divider={<Divider flexItem />}>
      {assignmentObjects.map((assignment) => (
        <AssignmentOverviewCard
          key={assignment._id}
          assignment={assignment}
          openModal={openModal}
          setPage={props.setPage}
          filter={filter}
        />
      ))}
    </Stack>
  );
}

function AssignmentOverviewCard(props) {
  const { assignment } = props;
  const { openModal } = props;
  const { filter } = props;
  const setAssignment = useSetAssignment();

  const viewAssignmentSubmissions = (event) => {
    setAssignment(assignment);

    openModal();
  };

  return (
    <Card
      component={Paper}
      elevation={3}
      sx={{
        minheight: 55,
        "&:hover": {
          backgroundColor: "rgb(183,193,211)",
        },
      }}
      aligncontent="center"
      justifycontent="center"
      //change to the editor page with the assignment
    >
      <CardActionArea onClick={viewAssignmentSubmissions}>
        <CardContent>
          <Grid
            container
            //spacing={1}
            //justifyContent = "center"
            //alignItems = "center"
          >
            <Grid item xs alignSelf="center">
              <Typography variant="h6" align="left">
                {assignment.name}
              </Typography>
            </Grid>
            <Grid item xs alignSelf="center">
              {filter != "unopened" && (
                <Typography align="center">View Submissions</Typography>
              )}
            </Grid>
            <Grid item xs alignSelf="center">
              <Typography variant="subtitle2" align="right">
                Due{" "}
                {new Date(assignment.due_date).toLocaleDateString("en-US", {
                  month: "short",
                  day: "numeric",
                  hour: "numeric",
                  minute: "numeric",
                })}
              </Typography>
              <Typography variant="subtitle2" align="right">
                Available{" "}
                {new Date(assignment.open_date).toLocaleDateString("en-US", {
                  month: "short",
                  day: "numeric",
                  hour: "numeric",
                  minute: "numeric",
                })}
              </Typography>
            </Grid>
          </Grid>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}
